<div class="mob-service-page-container">
  <div class="mob-service-page-background">
    <div class="mob-service-page-background-image"
         [style.background-image]="'url(' + location.img + ')'"
         [style.background-position]="location.backgroundPosition"
         [style.scale]="location.backgroundScale"
         [style.filter]="backgroundFilter">
    </div>
  </div>
  <div class="mob-service-page">
    <div class="mob-service-page-title">
      <app-texts [texts]="[{text: ['услуги', 'services']}]"/>
    </div>
    <div class="mob-service-page-content">
      <div class="mob-service-page-content-label">
        <app-texts [texts]="location.title"/>
      </div>
      <div class="mob-service-page-content-descr">
        <app-texts [texts]="[
          {text: [getSubtitle('rus'), getSubtitle('eng')]}
        ]"/>
      </div>
      <div class="mob-service-page-content-button" (click)="onClick()">
        <app-texts [texts]="[
          {text: ['Make request', 'Make request']}
        ]"/>
      </div>
    </div>
  </div>
</div>
